import React from 'react';
import Typography from '../Typography';
import Styled from './index.styled';
import Fade from 'react-reveal/Fade';
import { useTranslation } from 'react-i18next';

const FadeIn = (props) => <Fade distance="100px" {...props} /> 

const TextBlock = () => {
  const { t } = useTranslation();
  return (
    <Styled.Background>
      <Styled.Wrapper>
        <FadeIn up>
          <Styled.Heading>{t('IntroData.heading')}</Styled.Heading>
          <Typography.Body>{t('IntroData.description')}</Typography.Body>
        </FadeIn>
      </Styled.Wrapper>
    </Styled.Background>
  );
};

export default TextBlock;
